module.exports = __webpack_public_path__ + "static/media/baron-von-binance.0b675e66.png";